module.exports = __webpack_public_path__ + "img/shore-power.3b2cc662.svg";